export default {
  categories: {
    items: {
      text: {
        'ui:widget': 'EditorMarkdownWidget',
      },
      color: {
        'ui:widget': 'BaseColorWidget',
      },
      additionalInfo: {
        'ui:widget': 'EditorMarkdownWidget',
      },
      packages: {
        items: {
          value: {
            'ui:widget': 'EditorPackageWidget',
          },
        },
      },
    },
  },
}
